import {MessageModel} from '../../../../../message/api/model/messageModel';
import {BaseAuditableDto} from '../../../../../../shared/model/core/baseAuditableDto.model';
import {DiscussionParticipantModel} from './discussionParticipant.model';
import {LovValueSummary} from '../../../../../common/lov/lov-value/api/model/lovValueSummary.model';

export class DiscussionSummaryModel extends BaseAuditableDto{

    id: number;
    title: string;
    lastMessage: MessageModel;
    participants: DiscussionParticipantModel[];
    type: LovValueSummary;

}

export enum DiscussionType {
    DISCUSSION_TYPE_DEFAULT = 'DISCUSSION_TYPE_DEFAULT'
}

export enum DiscussionPermission {
    PERMISSION_ADD_PARTICIPANT = 'DISCUSSION_PERMISSION_ADD_PARTICIPANT'
}
export const DISCUSSION_BUSINESS_CONTEXT_NAME = 'Discussion';
